import { Component, OnInit } from '@angular/core';
import { SeoMetaService } from '../../services/seo-meta/seo-meta.service';

@Component({
  selector: 'app-feedback-process-pages',
  templateUrl: './feedback-process-pages.component.html',
  styleUrls: ['./feedback-process-pages.component.scss'],
})
export class FeedbackProcessPagesComponent implements OnInit {
  constructor(private seoMetaService: SeoMetaService) {}

  ngOnInit() {
    this.updateSeoMetaData();
  }

  private updateSeoMetaData(): void {
    this.seoMetaService.setTitle('feedback-process-pages.meta.title', true);
    this.seoMetaService.setMetaDescription(
      'feedback-process-pages.meta.description',
      true
    );
  }
}
